// extracted by mini-css-extract-plugin
export default {"trace-container":"g__trace-container--HS9Wf","json-value":"g__json-value--dOft_"};